import type { FC } from "react";

import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Typography } from "~/shared/ui-kit/typography/Typography";

import type { MainBannerV2Props } from "../MainBannerV2";

export const MainBannerRowItems: FC<MainBannerV2Props> = ({ data }) => {
  return (
    <Flex as="ul" flexDirection="column" className="pb-8 md:pb-[60px] px-4">
      {data?.items?.map((item) => (
        <Typography as="li" weight="normal" size="large" className="list-disc">
          {item?.main_banner_items_id?.text}
        </Typography>
      ))}
    </Flex>
  );
};
